import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';
import { JSX } from 'react';
import { useShallow } from 'zustand/shallow';

interface Notification {
	id: string;
	component: JSX.Element;
}

interface NotificationStore {
	notifications: Notification[];
	actions: {
		addNotification: (
			Component: (props: { id: string }) => JSX.Element
		) => string;
		removeNotification: (id: string) => void;
	};
}

const notificationStore = create<NotificationStore>((set) => ({
	notifications: [],

	actions: {
		addNotification: (Component) => {
			const id = uuidv4();
			const element = <Component id={id} />;
			set((state) => ({
				notifications: [...state.notifications, { id, component: element }],
			}));
			return id;
		},

		removeNotification: (id) => {
			set((state) => ({
				notifications: state.notifications.filter((n) => n.id !== id),
			}));
		},
	},
}));

export const useNotifications = () =>
	notificationStore(useShallow((state) => state.notifications));

export const useNotificationsStoreActions = () =>
	notificationStore((state) => state.actions);
